import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";
import ModalContentBase from "../modal/modal_content_base";
import WallCommentReply from "./wall_comment_reply";
import WallsCommentsLikeUsers from "./walls_comments_like_users";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    wallId: PropTypes.number,
    eventId: PropTypes.number,
    currentUser: PropTypes.object,
    isCommentShow: PropTypes.bool,
    isFormShow: PropTypes.bool,
    isCommentPageLinkShow: PropTypes.bool,
  },
  getInitialState() {
    return {
      isCommentShow: this.props.isCommentShow ? true : false,
      isManager: false,
      comment: "",
      comments: [],
      isUploading: false,
      isDisplay: true,
      deleteCommentId: 0,
      commentIdForLikeUsers: 0,
      modalLikeUsersRef: React.createRef(),
    };
  },
  handleComment(e) {
    this.setState({
      comment: e.target.value,
    });
  },
  handleCommentSubmitBtn() {
    this.setState({
      isUploading: true,
    });
    const formData = new FormData();
    formData.append("comment", this.state.comment);
    formData.append("wall_id", this.props.wallId);

    $.ajax({
      url: "/api/walls/walls_comment_write",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function() {
          this.setState({
            comment: "",
            isUploading: false,
          });
          this.loadCommentsFromServer();
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  loadCommentsFromServer() {
    $.ajax({
      url: "/api/walls/walls_comments",
      type: "GET",
      cache: false,
      data: {
        wall_id: this.props.wallId,
      },
      contentType: false,
    })
      .done(
        function(data) {
          var comments = data.wallsComments;
          if (comments.length > 4) {
            comments.splice(0, comments.length - 4);
          }
          this.setState({
            comments: comments,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  handleLikeButton(e) {
    e.preventDefault();

    const commentId = e.currentTarget.dataset.comment_id;
    const formData = new FormData();
    formData.append("walls_comment_id", commentId);
    $.ajax({
      url: "/api/walls/like_comment",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function() {
          this.loadCommentsFromServer();
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  handleShowLikeUsersButton(e) {
    e.preventDefault();
    this.setState({
      commentIdForLikeUsers: e.currentTarget.dataset.comment_id,
    });
    this.state.modalLikeUsersRef.current.openModal();
  },
  handleDeleteCommentBtn(e) {
    e.preventDefault();
    this.setState({
      deleteCommentId: e.currentTarget.dataset.comment_id,
    });
    this.deleteCommentConfirm.openModal();
  },
  deleteComment() {
    const formData = new FormData();
    formData.append("walls_comment_id", this.state.deleteCommentId);
    $.ajax({
      url: "/api/walls/delete_comment",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function() {
          this.loadCommentsFromServer();
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  handleReportCommentBtn(e) {
    e.preventDefault();
    // this.setState({
    // });
    this.reportCommentConfirm.openModal();
  },
  reportComment() {
    // @todo コメントの通報APIを作る
    this.reportCommentComplete.openModal();
  },
  componentDidMount() {
    if (this.props.isCommentShow) this.loadCommentsFromServer();
  },
  render() {
    const currentUser = this.props.currentUser ? this.props.currentUser : null;
    const eventId = this.props.eventId;
    const handleDeleteCommentBtn = this.handleDeleteCommentBtn;
    const isFormShow = this.props.isFormShow;
    const isCommentPageLinkShow = this.props.isCommentPageLinkShow;
    const handleLikeButton = this.handleLikeButton;
    const handleReportCommentBtn = this.handleReportCommentBtn;
    const handleShowLikeUsersButton = this.handleShowLikeUsersButton;
    const commentList = this.state.isCommentShow
      ? this.state.comments.map(function(comment) {
          if (!comment.user || comment.is_deleted) return;
          const like_user_ids = comment.walls_comments_like_users.map(function(
            like_user
          ) {
            return like_user.user_id;
          });
          return (
            <li key={comment.id}>
              <div className="row justify-content-around align-items-start mb-2_5">
                <div className="col-2 col-md-1 mr-2 mr-sm-0 mr-md-4 mr-lg-3">
                  <img
                    src={comment.company
                      ? (comment.companies_user ? comment.companies_user.avatar_thumb : "" ) 
                      : (comment.user ? comment.user.avatar_thumb : "")}
                    className="event-member-icon-medium rounded-circle"
                    alt=""
                  />
                </div>
                <div className="col pl-0">
                  <div className="d-flex justify-content-between pl-1">
                    {comment.company ? (
                      <a
                        href={"/community/" + comment.company.id_to_param + "/member/" + comment.companies_user.member_id}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="text-fz-12px text-fw-bold text-fz-green mb-0">
                          @{comment.companies_user
                            ? comment.company.is_real_name_required 
                            ? comment.companies_user.view_full_name_disp : 
                              comment.companies_user.nickname
                          : "退会ユーザー"}
                        </p>
                      </a>
                    ) : (
                      <a
                        href={"/member/profile/" + comment.user.tunagate_id}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="text-fz-12px text-fw-bold text-fz-green mb-0">
                          @{comment.user
                            ? comment.user.tunagate_id
                            : "退会ユーザー"}
                        </p>
                      </a>
                    )
                    }
                    <p className="text-fz-xs text-black-20 mb-0">
                      {currentUser && currentUser.id == comment.user_id ? (
                        <a
                          href=""
                          onClick={handleDeleteCommentBtn}
                          data-comment_id={comment.id}
                          className="text-black-20 pr-2"
                        >
                          削除
                        </a>
                      ) : (
                        ""
                      )}
                      {comment.created_at_time_ago_format}
                      <a
                        href=""
                        onClick={handleReportCommentBtn}
                        data-comment_id={comment.id}
                        className="text-black-20 p-3"
                      >
                        <img height={12} src="/assets2019/img/icon_reader.svg" alt="" />
                      </a>
                    </p>
                  </div>
                  <p
                    className="text-fz-11px mb-0 pl-1"
                    dangerouslySetInnerHTML={{
                      __html: comment.comment_display,
                    }}
                  />
                  {/* <div className="d-flex">
                    {!currentUser ? (
                      ""
                    ) : !like_user_ids.includes(currentUser.id) ? (
                      <a
                        href=""
                        onClick={handleLikeButton}
                        data-comment_id={comment.id}
                        className="text-black-20 ml-2"
                      >
                        ♡
                      </a>
                    ) : (
                      <p className="text-fz-xs text-black-20 mt-1 mb-0 ml-2">
                        いいね済
                      </p>
                    )}
                    {like_user_ids.length > 0 ? (
                      <a
                        href=""
                        onClick={!comment.company && handleShowLikeUsersButton}
                        data-comment_id={comment.id}
                        className="text-fz-xs text-black-20 mt-1 mb-0 ml-2"
                      >
                        {like_user_ids.length}件のいいね
                      </a>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <WallCommentReply
                    wallId={comment.wall_id}
                    wallsCommentId={comment.id}
                    currentUser={currentUser}
                    isFormShow={isFormShow}
                  />
                </div>
              </div>
            </li>
          );
        })
      : "";

    const commentForm =
      isFormShow && currentUser && !currentUser.is_banned ? (
        <div className="input-group pt-2 pb-2">
          <div className="col-2 col-md-1 pl-0 pl-0">
            <img
              src={currentUser ? currentUser.avatar_thumb : ""}
              className="event-member-icon-medium"
            />
          </div>
          <textarea
            className="form-control border-0 rounded h-1em bg-light-gray text-fz-16px"
            style={{ height: 58 }}
            type="text"
            rows="1"
            placeholder="質問・コメントする..."
            onChange={this.handleComment}
            value={this.state.comment}
          />
          <div className="input-group-append">
            <button
              className="btn text-black-50 text-fw-bold pt-1"
              onClick={this.handleCommentSubmitBtn}
            >
              送信
            </button>
          </div>
        </div>
      ) : isCommentPageLinkShow ? (
        <div className="container text-center">
          <p className="text-fz-11px">
            <a href={`/event/${eventId}/comments`}>質問・コメントページ</a>へ行く
          </p>
        </div>
      ) : (
        ""
      );
    const likeUsersModalContent = (
      <WallsCommentsLikeUsers
        wallsCommentId={this.state.commentIdForLikeUsers}
      />
    );
    let commentArea = this.state.isCommentShow ? (
      <div>
        <div className="bg-white mb-0">
          <div className=" pt-3 pb-0">
            <ul className="list-unstyled mb-0">{commentList}</ul>
            {commentForm}
          </div>
        </div>
        <ModalConfirm
          ref={(c) => {
            this.deleteCommentConfirm = c;
          }}
          title="コメントの削除"
          content="コメントを削除しますか？"
          approveFunc={this.deleteComment}
        />
        <ModalConfirm
          ref={(c) => {
            this.reportCommentConfirm = c;
          }}
          title="コメントを通報"
          content="コメントを通報しますか？"
          approveFunc={this.reportComment}
        />
        <ModalAlert
          ref={(c) => {
            this.reportCommentComplete = c;
          }}
          title="完了"
          content="コメントの通報が完了しました。"
        />
        <ModalContentBase
          ref={this.state.modalLikeUsersRef}
          previewContent={<div />}
          modalContent={likeUsersModalContent}
        />
      </div>
    ) : (
      ""
    );

    return this.state.isDisplay ? <div>{commentArea}</div> : "";
  },
});
